import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Box,
  IconButton,
  Typography,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { toast } from "react-toastify";

// Styled Components
const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: "12px",
    maxWidth: "500px",
    width: "100%",
    padding: theme.spacing(0),
    boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1.5),
  fontSize: "16px",
  fontWeight: 600,
  borderRadius: "8px",
  textTransform: "none",
  letterSpacing: "0.5px",
  boxShadow: "none",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  },
  transition: "all 0.3s ease",
}));

const Popup = ({ open, handleClose }) => {
  // const [open, setOpen] = useState(false); 
  const DESCO_API_BASE = import.meta.env.VITE_DESCO_API_BASE;
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  });

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setOpen(true);
  //   }, 1500);
  //   return () => clearTimeout(timer);
  // }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const formDataToSend = new FormData();
  formDataToSend.append("first_name", formData.firstName);
  formDataToSend.append("last_name", formData.lastName);
  formDataToSend.append("email", formData.email);
  formDataToSend.append("phone", formData.phoneNumber);

  try {
    const response = await axios.post(
      `${DESCO_API_BASE}/market_report_form/index`,
      formDataToSend
    );

    const pdfUrl = response?.data?.data;
    console.log("pdfUrl", pdfUrl);

    if (pdfUrl) {
      // Directly download the file from the URL
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.setAttribute("download", "market_report.pdf"); // Optional, works if the server supports it
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success("Thank you! Your report has been downloaded.");
    } else {
      toast.error("PDF URL missing in the response.");
    }

    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
    });
    handleClose();
  } catch (error) {
    console.error("Submission error:", error);
    toast.error("Error submitting form. Please try again.");
  }
};



  // const handleClose = () => setOpen(false);

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="market-report-dialog"
    >
      <Box sx={{ position: "relative" }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            zIndex: 1,
            color: "grey.600",
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box sx={{ p: 4 }}>
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: 700,
              fontSize: "1.5rem",
              px: 0,
              pt: 0,
            }}
          >
            <Typography variant="h5" component="div" gutterBottom>
              Exclusive Dubai Market Report
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ fontWeight: 400 }}
            >
              Get your free copy today
            </Typography>
          </DialogTitle>

          <Divider sx={{ my: 2 }} />

          <DialogContent sx={{ px: 0 }}>
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{ display: "flex", flexDirection: "column", gap: 2 }}
            >
              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  name="firstName"
                  label="First Name"
                  variant="outlined"
                  fullWidth
                  required
                  value={formData.firstName}
                  onChange={handleChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
                <TextField
                  name="lastName"
                  label="Last Name"
                  variant="outlined"
                  fullWidth
                  required
                  value={formData.lastName}
                  onChange={handleChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Box>

              <TextField
                name="email"
                label="Email"
                variant="outlined"
                fullWidth
                required
                type="email"
                value={formData.email}
                onChange={handleChange}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                  },
                }}
              />

              <TextField
                name="phoneNumber"
                label="Phone Number"
                variant="outlined"
                fullWidth
                required
                value={formData.phoneNumber}
                onChange={handleChange}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                  },
                }}
              />

              <StyledButton
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                sx={{
                  mt: 2,
                  background:
                    "linear-gradient(90deg, #d32f2f 0%, #b71c1c 100%)",
                }}
              >
                Get My Free Report
              </StyledButton>
            </Box>
          </DialogContent>
        </Box>
      </Box>
    </StyledDialog>
  );
};

export default Popup;
